
module.exports = new Class
({
	Extends: Htk.Field
	,Tag: 'htk-html'

	,render() {
		this.createRoot('div');
	}

	,putValue(value) {
		this.node.innerHTML = value;
	}
});
